const createQueue = async ({ params, api }) => {
  return await api('queue', { body: params.data, method: 'POST' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default createQueue;